let timeBack = 10;
const handleF = () => {
  const target = $("fieldset");
  console.log(target);
  if (target.length > 0) {
    $(target).on("change", () => {
      setTimeout(() => {
        const urlParams = new URLSearchParams(
          new URL(window.location.href).search
        );
        const variantValue = urlParams.get("variant");
        console.log(variantValue);
        BSS_B2B.cp.changeProductPrice(
          JSON.parse($("#bss-b2b-store-data").html()),
          "[bss-b2b-variant-id]",
          false,
          false,
          variantValue
        );
        handleF();
      }, 2000);
    });
  } else if (timeBack-- > 0) {
    setTimeout(handleF, 300);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    if (BSS_B2B.page.isProductPage()) {
      handleF();
    }
  }, 1000);
});

document.addEventListener("DOMContentLoaded", () => {
  const quickViewBtns = document.querySelectorAll(".quick-product__btn");
  quickViewBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        const modalContent = document.querySelector(".modal--is-active");
        const data = [];
        const dataEle = modalContent.querySelectorAll(
          "select.product-single__variants option"
        );
        if (dataEle.length) {
          for (let index = 0; index < dataEle.length; index++) {
            data[index] = dataEle[index].value;
          }
        }
        const variantsInputs = modalContent.querySelectorAll(".variant-input");
        if (variantsInputs.length) {
          for (let index = 0; index < variantsInputs.length; index++) {
            variantsInputs[index].addEventListener("click", () => {
              const priceEle = modalContent.querySelector(
                ".modal--is-active span[bss-b2b-product-id]"
              );
              setTimeout(() => {
                priceEle.setAttribute("bss-b2b-variant-id", data[index]);
                priceEle.removeAttribute("bss-b2b-product-active");
                console.log("priceEle", priceEle);
                BSS_B2B.cp.changeProductPrice(
                  JSON.parse($("#bss-b2b-store-data").html()),
                  false,
                  false,
                  true,
                  data[index]
                );
              }, 500);
            });
          }
        }
        console.log(data);
      }, 2000);
    });
  });
});

window.addEventListener("cart_changed", () => {
  setTimeout(() => {
    BSS_B2B.cart.fixer(
      JSON.parse($("#bss-b2b-store-data").html()),
      false,
      false
    );
  }, 700);
});
